module.exports = __webpack_public_path__ + "img/token-hunt-variant-1.4c78a86e.webp";